import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { TestResultEntryComponent } from "./testresultentry/testresultentry.component";
import { DailyExpensesDetailsComponent } from "./daily-expenses-details/daily-expenses-details.component";
import { SampleCollectedComponent } from "./sample-collected/sample-collected.component";
import { SampleRecevingComponent } from "./sample-receving/sample-receving.component";


const routes: Routes = [
  {path:"samplCollection",component:SampleCollectedComponent},
  {path:"sampleReceving",component:SampleRecevingComponent},
  { path: "testresultentry",component:TestResultEntryComponent},
  { path: "testresultapproval",component:TestResultEntryComponent},
  { path: "dailyexpensesdetails",component:DailyExpensesDetailsComponent},
  
  
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LabEntryRoutingModule {}
